import Color from 'color';

export const SKOG = '#00754e';
export const FROST_30 = '#d8e9f2';
export const FROST_70 = '#a5cbe0';
export const SAND_30 = '#fdf8f5';
export const SAND_70 = '#faf0e7';
export const VANN_30 = '#b3cee4';
export const VANN = '#005aa4';
export const BAER = '#e44244';
export const NORDLYS = '#33af85';
export const SOL = '#dc8000';
export const MULTE = '#f8b181';
export const VILLBLOMST = '#ee8d9c';
export const FJELL = '#002776';
export const LYNG = '#873953';
export const SVART = '#262626';
export const HVIT = '#fff';
export const SYRIN_30 = '#f2f2f9';

const whiteColor = Color(HVIT);
export const calculateOrganisationColors = (themeColor) => {
    if (themeColor) {
        const color = Color(themeColor);

        const supportColor1 = whiteColor.mix(color, 0.3);
        const supportColor2 = whiteColor.mix(color, 0.7);

        return {
            primaryColor: themeColor,
            secondaryColor: supportColor1.hex(),
            tertiaryColor: supportColor2.hex(),
            primaryTextColor: color.isDark() ? HVIT : SVART,
            hoverColor: color.darken(0.4).hex(),
            secondaryTextColor: supportColor1.isDark() ? HVIT : SVART,
            tertiaryTextColor: supportColor2.isDark() ? HVIT : SVART,
        };
    } else {
        return {
            secondaryColor: FROST_30,
            tertiaryColor: FROST_70,
            sandColor: SAND_70,
            sandTextColor: SVART,
            secondaryTextColor: FJELL,
            tertiaryTextColor: FJELL,
        };
    }
};

export const getSupportColor1 = (color) => {
    return color && whiteColor.mix(Color(color), 0.3).hex();
};

export const getSupportColor2 = (color) => {
    return color && whiteColor.mix(Color(color), 0.7).hex();
};
